import React, { Component } from 'react';
import { Modal, DatePicker, message, Spin, Input, Radio } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import moment from 'moment';
import SearchRetrieve from '../../../common/SearchRetrieve.new';

const dateFormat = "YYYY-MM-DD";
const RadioGroup = Radio.Group;

class RegisterCovTime extends Component {
    state = {
        list: [],
        params: {},
        visible: false,
        loading: false,
    }

    show = (params) => {
        const { invShow } = params;
        this.setState({
            visible: true,
            params: {
                ...params,
                isInv: invShow,
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params: { userId, teacherId, areaId, covTime, isInv, invId } } = this.state;
        if (!covTime) {
            return message.warning('COV计划日期不能为空')
        }
        if (!isInv) {
            return message.warning('是否涉及项目不能为空')
        }
        if (isInv == 'true' && !invId) {
            return message.warning('涉及项目简称不能为空')
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.registerCovTime, {
            userId,
            teachId: teacherId,
            areaId,
            covTime: covTime ? covTime.slice(0, 10) : '',
            isInv,
            invId,
        }).then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    handleSearchRetrieveChange = (option, key) => {
        const { params } = this.state;
        params[`${key}Id`] = option.value;
        params[`${key}Name`] = option.text;
        this.setState({ params });
    }

    disabledDate = (current) => {
        const { params: { independentInvTime } } = this.state;
        const value = moment(independentInvTime).add(31, 'd').valueOf();
        return current && current.valueOf() > value;
    }

    getContent = () => {
        const { params } = this.state;
        const { covTime, isInv, invName, userId } = params;
        
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}COV计划日期:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            disabledDate={this.disabledDate}
                            format={dateFormat}
                            value={covTime ? moment(covTime) : null}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "covTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}是否涉及项目:</div>
                    <div className="item-right">
                        <RadioGroup
                            style={{ width: 182 }}
                            value={isInv}
                            onChange={(e) => this.handleChange(e.target.value, 'isInv')}
                        >
                            <Radio value={"true"}>是</Radio>
                            <Radio value={"false"}>否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                {
                    isInv == 'true' &&
                    <li className="modal-item">
                        <div className="item-left">{asterisk}涉及项目简称:</div>
                        <div className="item-right">
                            <SearchRetrieve
                                keyword='invName'
                                style={{ width: 182 }}
                                params={{ limit: 20, userId}}
                                placeholder="请输入名称检索"
                                value={invName}
                                url={API_URL.teaching.queryInvList}
                                config={{ id: 'investigationId', name: 'investigationName', type: 'covTimeInvList' }}
                                onChange={option => this.handleSearchRetrieveChange(option, 'inv')}
                            />
                        </div>
                    </li>
                }
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="登记COV计划时间"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default RegisterCovTime;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/RegisterCovTime.js